import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';
import log from '../../lib/log';
import { getSession, setSessionDeletionTimestamp } from '../../lib/sessions';
import { serviceState } from '../../lib/state';

// this is the handler that is triggered when user hangs up the call
async function handleSessionDeleted(event: Telecom.SessionDeletedEvent) {
  log('rtcs:session:deleted', event);

  appManager.events.emit<ServiceSessionEvent>(ServiceSessionEventType.DELETED, {
    sessionId: event.conversationId,
    sessionSid: event.conversationSid,
  });

  // Record even when this viewer never stored the session (reload / missed
  // session.created). Otherwise a buffered offer can recreate a ghost session.
  setSessionDeletionTimestamp(event.conversationSid, event.timestamp);

  const session = getSession(event.conversationId);
  if (!session) {
    console.warn('session not found', event.conversationId);
    return;
  }

  delete serviceState.sessions[event.conversationId];
}

export default handleSessionDeleted;
